"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFailureModes = void 0;
const Predicate_1 = require("effect/Predicate");
const capability_1 = require("../../capability");
const definition_1 = require("../../capability/consumable/definition");
const _util_1 = require("../_util");
const getFailureModes = (device) => {
    const [liquidEnhancement1, liquidEnhancement2, liquidEnhancement3, liquidEnhancement4, liquidEnhancement5, liquidEnhancement6, liquidEnhancement7, liquidEnhancement8, preCarbonBlockFilter, carbonBlockFilter, limescaleFilter, uvcLight, co2Tank,] = device.consumables;
    const alarms = device.alarms.map(({ alarm }) => alarm);
    const enhancements = [
        liquidEnhancement1,
        liquidEnhancement2,
        liquidEnhancement3,
        liquidEnhancement4,
        liquidEnhancement5,
        liquidEnhancement6,
        liquidEnhancement7,
        liquidEnhancement8,
        co2Tank,
    ];
    const filters = [preCarbonBlockFilter, carbonBlockFilter, limescaleFilter];
    return {
        sanitization: [(0, _util_1.getFailureModeNullableSlot)(uvcLight, definition_1.Definitions.UVCLight)],
        dripTrayAndLeak: [
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.LeakBottom),
            (0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.DripFull),
        ],
        enhancements: enhancements.filter(Predicate_1.isNotNullable).map(_util_1.getFailureModeSlot),
        heatingStatus: [(0, _util_1.getFailureModeAlarm)(alarms, capability_1.Alarm.HotNTC)],
        chillingStatus: [],
        waterQuality: filters.filter(Predicate_1.isNotNullable).map(_util_1.getFailureModeSlot),
    };
};
exports.getFailureModes = getFailureModes;
//# sourceMappingURL=failure-mode.js.map